// removed by extract-text-webpack-plugin
module.exports = {"attachment-icon-wrapper":"attachment-icon-wrapper","attachment-icon":"attachment-icon","trashcan":"trashcan","trashcan-open":"trashcan-open","trashcan-closed":"trashcan-closed"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fileDetector/fileDetector.scss
// module id = 5115
// module chunks = 1